import type { ChainId } from '@morpho-org/blue-sdk'
import type { Address } from 'viem'

import type {
  VaultTransactionsInput,
  VaultTransactionsOutput
} from '@/lib/procedures/vaultTransactions.contract'

import { orpc } from '@/lib/orpc/client'

export type VaultTransactionsQueryInput = Omit<VaultTransactionsInput, 'cursor'> & {
  chainId: ChainId
  address: Address
}

/** What a vault the bridge does not know shows: no transactions. */
export const NO_TRANSACTIONS: VaultTransactionsOutput = {
  asset: null,
  items: [],
  partial: false,
  nextCursor: null
}

/**
 * The key the server seeds and `useVaultTransactionsTableData` reads. The viewer table is keyed
 * apart from the activity table so the two never share a cache entry.
 */
export const vaultTransactionsQueryKey = (
  input: VaultTransactionsQueryInput,
  scope: 'activity' | 'viewer'
) => [
  ...orpc.vault.transactions.key({ input, type: 'infinite' }),
  ...(scope === 'viewer' ? (['viewer'] as const) : [])
]

/** The procedure's `nextCursor` page, in the `pageInfo` shape `useCursorPagination` walks. */
export function toCursorPage(page: VaultTransactionsOutput) {
  return {
    ...page,
    pageInfo: { hasNextPage: page.nextCursor !== null, endCursor: page.nextCursor }
  }
}

export type VaultTransactionsCursorPage = ReturnType<typeof toCursorPage>
